import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import H1 from '../../atoms/title/H1';
import Layout from '../../templates/Layout';
import { Helmet } from 'react-helmet';
import { router } from '@inertiajs/react';
import ReportExportTable from '../../organisms/table/ReportExportTable';
import Notice from '../../molecules/Notice';
import FileTable from '../../organisms/table/FileTable';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const StyledH1 = styled(H1) `
    margin-top: 30px;
`;
const ExportOverview = ({ reportExports, files, notice, }) => {
    const { t } = useTranslation();
    const unfinishedReports = reportExports.data.filter(reportExport => ['pending', 'running'].indexOf(reportExport.status) > -1);
    useEffect(() => {
        if (unfinishedReports.length > 0) {
            const timeOut = setTimeout(() => {
                router.reload({
                    only: ['reportExports'],
                });
            }, 10000);
            return () => clearTimeout(timeOut);
        }
    }, [reportExports]);
    return (_jsxs(Layout, { "data-testid": "report-export-overview", children: [_jsx(Helmet, { children: _jsx("title", { children: t('report_export.title') }) }), notice && (_jsx(Notice, { type: notice.type, text: notice.text, title: notice.title })), files.data.length > 0 && (_jsxs(_Fragment, { children: [_jsx(H1, { "data-testid": "title", children: t('file.title') }), _jsx(FileTable, { files: files.data })] })), _jsx(StyledH1, { children: t('report_export.title') }), _jsx(ReportExportTable, { reportExports: reportExports.data })] }));
};
export default ExportOverview;
